import React from 'react';
import Header from '../../CoreFile/Header';
import Footer from '../../CoreFile/Footer';
import { PrivacyHeroSection } from './PrivacyHeroSection';

export const Privacy = () => {
  return (
    <>
      <Header />
      <PrivacyHeroSection/>

      <div className="bg-gray-50 text-gray-900 px-4 py-12">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl font-bold mb-6 text-center text-blue-600">
            Privacy Policy
          </h1>
          <p className="text-center max-w-3xl mx-auto text-lg mb-12">
            At GFM, your privacy is our priority. This policy outlines how we collect,
            use, protect, and handle your personal data when you interact with our platform.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Data Collection */}
            <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-200">
              <h2 className="text-xl font-semibold text-indigo-600 mb-4">
                📥 Information We Collect
              </h2>
              <ul className="space-y-3">
                <li>✅ Personal details (name, email, etc.) during account creation.</li>
                <li>✅ Transaction and trading activity for operational purposes.</li>
                <li>✅ Device and usage data to enhance user experience and platform security.</li>
              </ul>
            </div>

            {/* Use of Information */}
            <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-200">
              <h2 className="text-xl font-semibold text-indigo-600 mb-4">
                🛠️ How We Use Your Data
              </h2>
              <ul className="space-y-3">
                <li>✅ To process trades, manage accounts, and deliver support.</li>
                <li>✅ To analyze trends and improve our platform and services.</li>
                <li>✅ To send relevant updates, alerts, or promotional content (opt-in only).</li>
              </ul>
            </div>

            {/* Data Security */}
            <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-200">
              <h2 className="text-xl font-semibold text-indigo-600 mb-4">
                🔒 Data Security
              </h2>
              <ul className="space-y-3">
                <li>✅ We use industry-standard encryption and secure servers to protect your data.</li>
                <li>✅ Access to personal data is restricted to authorized personnel only.</li>
                <li>✅ We regularly audit and update our security protocols.</li>
              </ul>
            </div>

            {/* Sharing & User Rights */}
            <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-200">
              <h2 className="text-xl font-semibold text-indigo-600 mb-4">
                👥 Third-Party Sharing & Your Rights
              </h2>
              <ul className="space-y-3">
                <li>✅ We do not sell or trade your personal information.</li>
                <li>✅ We may share data with trusted providers for necessary services (e.g., payment processing).</li>
                <li>✅ You have the right to access, update, or request deletion of your data at any time.</li>
              </ul>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-base text-gray-700">
              By using Glod Fox Market, you agree to this Privacy Policy. We may update this policy
              periodically, and any changes will be posted on this page.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};
